import { StoredTimePart } from "src/app/storage/models/stored-utilities/stored-time-part";

/**
 * An instance of the StoredTimePart model to be used for schema validation
 */
export const storedTimePartInstance: StoredTimePart = {
	Hours: 0,
	Minutes: 0,
	Seconds: 0
}